export default {
    title: 'VERI*FACTU',
    whatIs: {
        title: 'What is VERI*FACTU?',
        p1: 'VERI*FACTU is not software itself, but a set of technical and legal requirements that Billing Computer Systems (SIF) in Spain must comply with.',
        p2: 'Its objective: to guarantee the transparency, traceability, and integrity of invoices — preventing manipulations, parallel accounting ("black boxes"), deletions, or alterations of records.'
    },
    whoIsAffected: {
        title: 'Who is affected?',
        p1: 'It affects companies, professionals, and freelancers who use computer or electronic systems to issue invoices.',
        p2: 'If a person issues invoices manually — for example with a simple printed document or template without accounting functionalities — they would not be obliged to comply with VERI*FACTU.'
    },
    requirements: {
        title: 'Main requirements of billing systems with VERI*FACTU',
        intro: 'When you use a SIF, it must comply with various technical and security criteria:',
        li1: 'Automatic and unique registration for each invoice issued (including new invoices, cancellations, or rectifications).',
        li2: 'Inalterability of records: invoices cannot be modified or deleted without leaving a trace; electronic signatures, chained hashes, or other secure mechanisms are used.',
        li3: 'Traceability and conservation: records must be kept accessible, legible, and preserved in conditions that allow their consultation if required by the authority.',
        li4: '“Veri*Factu” identification on the invoice: when this system is used, the invoice must warn that it has been generated under VERI*FACTU and, usually, include a QR code with identifying data.',
        li5: 'Possibility of sending to the Tax Agency (AEAT): systems must allow, if desired, sending billing records to AEAT, preferably in real-time or immediately before issuing the invoice.'
    },
    optionVerifactu: {
        title: 'Verifactu Option',
        p1: 'Before choosing the Verifactu option, the user must know that this option must be maintained during the current year, that is, it will not be possible to change to another option until January 1 of the following year.',
        p2: 'With the Verifactu option, once invoices are sent, XML files will be automatically generated and sent to the AEAT, as required.',
        p3: 'Information about this process can be seen in the Events tab, within the details of the sent invoice.',
        p4: 'The generated QR code can also be seen in the invoice PDF, at the beginning of it.'
    },
    optionNoVerifactu: {
        title: 'No Verifactu Option',
        p1: 'If the No Verifactu option is chosen, the platform will automatically generate the XML files for each invoice sent, but these files will be kept stored internally, without being sent to the AEAT, until it requests them from the user.',
        p2: 'At that time, the user will contact us and we will send the requested files.'
    },
    deadlines: {
        title: 'Implementation deadlines',
        p1: 'The effective obligation to use compatible software falls on companies — especially corporations — from January 1, 2027. For freelancers and professionals, the deadline extends to July 2027.',
        p2: "Although the use of “VERI*FACTU mode” is not mandatory for everyone — one can choose to keep records internally — 'No Verifactu' option, the software must comply with the requirements of the regulation."
    },
    why: {
        title: 'Why is VERI*FACTU being promoted?',
        intro: 'The main objectives are:',
        li1: 'Combat tax fraud by reducing the use of parallel accounting.',
        li2: 'Ensure the transparency, integrity, and reliability of billing in Spain.',
        li3: 'Accompany the digitization of invoice management and adapt to new times, with secure, structured, and verifiable systems.'
    },
    documentation: {
        title: 'Official documentation',
        link1Text: 'Royal Decree 254/2025',
        link1Suffix: ', of April 1, modifying Royal Decree 1007/2023, of December 5, approving the Regulation establishing the requirements that must be adopted by computer or electronic systems and programs that support billing processes of entrepreneurs and professionals, and the standardization of billing record formats.',
        link2Text: 'Frequently asked questions by companies, SMEs, and freelancers.'
    },
    requerimiento: {
        title: 'Send by requirement',
        numeroRequerimiento: {
            label: 'Requirement number',
            helper: 'Max. 18 characters'
        },
        filter: {
            title: 'Invoice search',
            period: 'Search period',
            from: 'From',
            to: 'To'
        },
        modal: {
            title: 'Requirement number'
        },
        table: {
            serieFactura: 'Serie',
            numeroFactura: 'Invoice number',
            fechaExpedicionFactura: 'Issue date',
            razonSocialEmisor: 'Provider',
            razonSocialDestinatario: 'Recipient',
            importeTotal: 'Amount'
        },
        button: {
            send: 'Send selected',
            back: 'Back'
        },
        empty: 'There are no invoices pending of requirement',
        notRegisteredModality: 'You are not registered in the VeriFactu requirement modality. This section is only available to users with that modality.',
        result: {
            title: 'Send result',
            numeroRequerimiento: 'Requirement number',
            nRegistros: 'Records',
            finRequerimiento: 'End of requirement',
            pendientes: 'Pending',
            error: 'Error',
            estadoEnvio: 'Send status',
            csv: 'CSV',
            yes: 'Yes',
            no: 'No'
        }
    },
    enviadas: {
        title: 'Verifactu - Remitted invoices',
        table: {
            idFactura: 'Invoice id',
            modalidad: 'Modality',
            fechaHoraEnvio: 'Send date/time',
            download: 'Download'
        },
        modalidad: {
            voluntario: 'Voluntary',
            requerimiento: 'Requirement'
        },
        errors: {
            download: 'Unable to download the invoice file'
        },
        empty: 'There are no invoices sent to VeriFactu'
    },
    comprobarHuella: {
        title: 'Check hash',
        empty: 'There are no records to check',
        tabs: {
            facturacion: 'Invoicing',
            eventos: 'Events'
        },
        table: {
            idFactura: 'Invoice Id',
            serie: 'Serie',
            numero: 'Number',
            fechaExpedicion: 'Issue date',
            importe: 'Amount',
            id: 'Id',
            tipoEvento: 'Event type',
            fechaHora: 'Date/time',
            comprobar: 'Check'
        },
        eventTypes: {
            '01': 'SIF start-up',
            '02': 'SIF shutdown',
            '03': 'Launch of invoicing anomalies',
            '04': 'Detection of invoicing anomalies',
            '05': 'Launch of event anomalies',
            '06': 'Detection of event anomalies',
            '07': 'Backup restoration',
            '08': 'Export of invoicing records',
            '09': 'Export of event records',
            '10': 'Events summary',
            '90': 'Other voluntary events'
        },
        resultado: {
            title: 'Check result',
            campo: 'Field',
            valor: 'Value',
            valida: 'Valid hash',
            noValida: 'Non-valid hash',
            tipoRegistro: 'Record type',
            tipoEvento: 'Event type',
            idFactura: 'Invoice Id',
            idEvento: 'Event Id',
            serie: 'Serie',
            numero: 'Number',
            fechaExpedicion: 'Issue date',
            fechaHora: 'Date/time',
            huellaCalculada: 'Calculated hash',
            huellaEsperada: 'Stored hash',
            cadenaReferencia: 'Reference chain',
            anterior: 'Previous record',
            id: 'Id'
        },
        errors: {
            comprobar: 'Unable to check the hash of the record'
        }
    },
    exportarRegistros: {
        title: 'Verifactu - Export records',
        nif: 'NIF',
        intro: 'Generates the ZIP files with the invoices and the events registered in the selected period, even if they were exported before.',
        filter: {
            title: 'Records search',
            period: 'Export period',
            from: 'From',
            to: 'To'
        },
        button: 'Export records',
        processing: 'Generating events...',
        result: {
            ok: '{count} file(s) generated for NIF {nif}',
            ko: 'Export error for NIF {nif}'
        },
        downloadFacturacion: 'Download invoices (ZIP)',
        downloadEventos: 'Download events (ZIP)'
    }
}
